import type { PageContext } from 'vike/types'
import { cleanAddressPart } from '@repo/ui'
export default function title(pageContext: PageContext): string {
  const { mode, place } = pageContext.routeParams
  const { page } = pageContext.data
  const key = `seo.${mode}.${place ? 'city' : 'nationwide'}.title`
  const name = pageContext.locale === 'ja' ? page.name : page.roman ?? page.name
  return pageContext.i18n.global.t(key, { city: cleanAddressPart(name ?? '') })
}
